import styled from 'styled-components';
import Chip from '@mui/material/Chip';

import { Link } from 'react-router-dom';

import { Styling, Colors } from '../../../constants';

export const LinkOverride = styled(Link)`
  text-decoration: none;
`;

export const ActiveChip = styled(Chip)`
  border: 1px solid green !important;
  background-color: #d0f7d0 !important;
  color: #0d3e0d !important;
`;

export const ConsentRequiredChip = styled(Chip)`
  border: 1px solid #b9a640 !important;
  background-color: #fff7b6 !important;
  color: #5d5b0a !important;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  min-width: ${Styling.MIN_WIDTH}px;
  flex-grow: 1;
  padding: ${Styling.DEFAULT_SPACING}px;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
`;

export const Header = styled.div`
  width: 100%;
  flex-grow: 0;
  background-color: #f9f8f8;
  padding: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HeaderTitle = styled.h2`
  color: black;
  font-size: 18px;
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  a, button {
    width: 100%;

    &:not(:last-child) {
      margin-right: ${Styling.DEFAULT_SPACING}px;
    }
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

export const ErrorLoadingText = styled.span`
  font-size: 28px;
  color: ${Colors.BLACK_50};
  padding: ${Styling.DEFAULT_SPACING}px;
`;

export const NoItemsText = styled.span`
  font-size: 28px;
  color: ${Colors.BLACK_50};
  padding: ${Styling.DEFAULT_SPACING}px;
`;

export const IdText = styled.span`
  color: ${Colors.BLACK_40};
`;
